import React from "react";
import Home from "./static/Home";
import About from "./static/About";
import Product from "./static/Product";
import Contact from "./Contact";

const Main = () => {
  return (
    <>
      <Home />
      <About />
      <Product />
      <Contact />
    </>
  );
};

export default Main;
